import { Timestamp } from 'firebase/firestore';

/**
 * sort_key の最大タイムスタンプ値（反転用）
 * 9999999999999 = 2286-11-20T17:46:39.999Z
 */
const MAX_TIMESTAMP = 9999999999999;

/**
 * resultのソート用キーを生成する
 *
 * 形式: {invertedTimestamp}_{fileIndex}_{pageNumber}
 * - invertedTimestamp: MAX_TIMESTAMP - created_atミリ秒（降順を実現）
 * - fileIndex: 5桁ゼロパディング（昇順）
 * - pageNumber: 5桁ゼロパディング（昇順）
 *
 * orderBy('sort_key', 'asc') で
 * created_at降順 → file_index昇順 → page_number昇順 になる
 */
export const generateSortKey = (
  createdAt: Timestamp | Date,
  fileIndex = 0,
  pageNumber = 1,
): string => {
  const millis = createdAt instanceof Timestamp ? createdAt.toMillis() : createdAt.getTime();
  const invertedTime = MAX_TIMESTAMP - millis;
  const paddedFileIndex = String(fileIndex).padStart(5, '0');
  const paddedPageNumber = String(pageNumber).padStart(5, '0');
  return `${invertedTime}_${paddedFileIndex}_${paddedPageNumber}`;
};
